import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import '@carbon/web-components/es/components/tile/tile.js';
import '@carbon/web-components/es/components/progress-indicator/index.js';

import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import '../flow/pdq-json';
import '../flow/pdq-perspective-viewer';
import './PDQCodeHtml';
import  '../ui/pdq-search';
import { row, w100, w75, w25, w50 } from '../styles';

import '../ui/tree/pdq-tree-view';
import '../ui/tree/pdq-tree-view-item';

@customElement('pdq-tutorial-search')
export class PDQTutorialSearch extends LitElement {
  static styles = [
    row, w100, w75, w50, w25
  ]

  render() {
    const data = `<pdq-json id="counties">
  <script slot="json" type="application/json">
[
  {
    "country": "England",
    "county": "Bedfordshire",
    "population": 669338
  },
  {
    "country": "England",
    "county": "Berkshire",
    "population": 911403
  },
  {
    "country": "England",
    "county": "Bristol",
    "population": 463405
  },
  {
    "country": "England",
    "county": "Buckinghamshire",
    "population": 543973
  },
  {
    "country": "England",
    "county": "Cambridgeshire",
    "population": 852523
  },
  {
    "country": "England",
    "county": "Cheshire",
    "population": 1059271
  },
  {
    "country": "England",
    "county": "Cornwall",
    "population": 571802
  },
  {
    "country": "England",
    "county": "Cumbria",
    "population": 498888
  },
  {
    "country": "England",
    "county": "Derbyshire",
    "population": 1053316
  },
  {
    "country": "England",
    "county": "Devon",
    "population": 795286
  },
  {
    "country": "England",
    "county": "Dorset",
    "population": 772268
  },
  {
    "country": "England",
    "county": "Durham",
    "population": 530094
  },
  {
    "country": "England",
    "county": "East Sussex",
    "population": 558852
  },
  {
    "country": "England",
    "county": "Essex",
    "population": 1832752
  },
  {
    "country": "England",
    "county": "Gloucestershire",
    "population": 637070
  },
  {
    "country": "England",
    "county": "Greater London",
    "population": 8961989
  },
  {
    "country": "England",
    "county": "Greater Manchester",
    "population": 2812569
  },
  {
    "country": "England",
    "county": "Hampshire",
    "population": 1844245
  },
  {
    "country": "England",
    "county": "Herefordshire",
    "population": 192801
  },
  {
    "country": "England",
    "county": "Hertfordshire",
    "population": 1189519
  },
  {
    "country": "England",
    "county": "Isle of Wight",
    "population": 141538
  },
  {
    "country": "England",
    "county": "Kent",
    "population": 1846478
  },
  {
    "country": "England",
    "county": "Lancashire",
    "population": 1498300
  },
  {
    "country": "England",
    "county": "Leicestershire",
    "population": 1053486
  },
  {
    "country": "England",
    "county": "Lincolnshire",
    "population": 1087659
  },
  {
    "country": "England",
    "county": "Merseyside",
    "population": 1423065
  },
  {
    "country": "England",
    "county": "Norfolk",
    "population": 903680
  },
  {
    "country": "England",
    "county": "North Yorkshire",
    "population": 1158816
  },
  {
    "country": "England",
    "county": "Northamptonshire",
    "population": 747622
  },
  {
    "country": "England",
    "county": "Northumberland",
    "population": 322434
  },
  {
    "country": "England",
    "county": "Nottinghamshire",
    "population": 1154191
  },
  {
    "country": "England",
    "county": "Oxfordshire",
    "population": 687524
  },
  {
    "country": "England",
    "county": "Rutland",
    "population": 39697
  },
  {
    "country": "England",
    "county": "Shropshire",
    "population": 498073
  },
  {
    "country": "England",
    "county": "Somerset",
    "population": 965424
  },
  {
    "country": "England",
    "county": "South Yorkshire",
    "population": 1402918
  },
  {
    "country": "England",
    "county": "Staffordshire",
    "population": 1126053
  },
  {
    "country": "England",
    "county": "Suffolk",
    "population": 758556
  },
  {
    "country": "England",
    "county": "Surrey",
    "population": 1189934
  },
  {
    "country": "England",
    "county": "Tyne and Wear",
    "population": 1136371
  },
  {
    "country": "England",
    "county": "Warwickshire",
    "population": 571010
  },
  {
    "country": "England",
    "county": "West Midlands",
    "population": 2916458
  },
  {
    "country": "England",
    "county": "West Sussex",
    "population": 858852
  },
  {
    "country": "England",
    "county": "West Yorkshire",
    "population": 2320214
  },
  {
    "country": "England",
    "county": "Wiltshire",
    "population": 500024
  },
  {
    "country": "England",
    "county": "Worcestershire",
    "population": 595786
  },
  {
    "country": "Scotland",
    "county": "Aberdeenshire",
    "population": 261470
  },
  {
    "country": "Scotland",
    "county": "Angus",
    "population": 116040
  },
  {
    "country": "Scotland",
    "county": "Argyll and Bute",
    "population": 86260
  },
  {
    "country": "Scotland",
    "county": "Ayrshire",
    "population": 366800
  },
  {
    "country": "Scotland",
    "county": "Clackmannanshire",
    "population": 51400
  },
  {
    "country": "Scotland",
    "county": "Dumfries and Galloway",
    "population": 148790
  },
  {
    "country": "Scotland",
    "county": "Dundee",
    "population": 148820
  },
  {
    "country": "Scotland",
    "county": "East Lothian",
    "population": 105790
  },
  {
    "country": "Scotland",
    "county": "Edinburgh",
    "population": 524930
  },
  {
    "country": "Scotland",
    "county": "Fife",
    "population": 371910
  },
  {
    "country": "Scotland",
    "county": "Glasgow",
    "population": 633120
  },
  {
    "country": "Scotland",
    "county": "Highland",
    "population": 235830
  },
  {
    "country": "Scotland",
    "county": "Inverclyde",
    "population": 77800
  },
  {
    "country": "Scotland",
    "county": "Midlothian",
    "population": 92460
  },
  {
    "country": "Scotland",
    "county": "Moray",
    "population": 95820
  },
  {
    "country": "Scotland",
    "county": "Orkney",
    "population": 22270
  },
  {
    "country": "Scotland",
    "county": "Perth and Kinross",
    "population": 151950
  },
  {
    "country": "Scotland",
    "county": "Renfrewshire",
    "population": 179100
  },
  {
    "country": "Scotland",
    "county": "Scottish Borders",
    "population": 115510
  },
  {
    "country": "Scotland",
    "county": "Shetland",
    "population": 22920
  },
  {
    "country": "Scotland",
    "county": "Stirling",
    "population": 94330
  },
  {
    "country": "Scotland",
    "county": "Western Isles",
    "population": 26830
  },
  {
    "country": "Wales",
    "county": "Anglesey",
    "population": 70440
  },
  {
    "country": "Wales",
    "county": "Blaenau Gwent",
    "population": 69713
  },
  {
    "country": "Wales",
    "county": "Bridgend",
    "population": 147049
  },
  {
    "country": "Wales",
    "county": "Caerphilly",
    "population": 181731
  },
  {
    "country": "Wales",
    "county": "Cardiff",
    "population": 366903
  },
  {
    "country": "Wales",
    "county": "Carmarthenshire",
    "population": 188771
  },
  {
    "country": "Wales",
    "county": "Ceredigion",
    "population": 72695
  },
  {
    "country": "Wales",
    "county": "Conwy",
    "population": 117203
  },
  {
    "country": "Wales",
    "county": "Denbighshire",
    "population": 95696
  },
  {
    "country": "Wales",
    "county": "Flintshire",
    "population": 156847
  },
  {
    "country": "Wales",
    "county": "Gwynedd",
    "population": 124178
  },
  {
    "country": "Wales",
    "county": "Merthyr Tydfil",
    "population": 60424
  },
  {
    "country": "Wales",
    "county": "Monmouthshire",
    "population": 94142
  },
  {
    "country": "Wales",
    "county": "Neath Port Talbot",
    "population": 143315
  },
  {
    "country": "Wales",
    "county": "Newport",
    "population": 154676
  },
  {
    "country": "Wales",
    "county": "Pembrokeshire",
    "population": 125818
  },
  {
    "country": "Wales",
    "county": "Powys",
    "population": 132435
  },
  {
    "country": "Wales",
    "county": "Rhondda Cynon Taf",
    "population": 241264
  },
  {
    "country": "Wales",
    "county": "Swansea",
    "population": 246993
  },
  {
    "country": "Wales",
    "county": "Torfaen",
    "population": 93961
  },
  {
    "country": "Wales",
    "county": "Vale of Glamorgan",
    "population": 133587
  },
  {
    "country": "Wales",
    "county": "Wrexham",
    "population": 135957
  },
  {
    "country": "Northern Ireland",
    "county": "Antrim",
    "population": 618108
  },
  {
    "country": "Northern Ireland",
    "county": "Armagh",
    "population": 214090
  },
  {
    "country": "Northern Ireland",
    "county": "Down",
    "population": 531665
  },
  {
    "country": "Northern Ireland",
    "county": "Fermanagh",
    "population": 116835
  },
  {
    "country": "Northern Ireland",
    "county": "Londonderry",
    "population": 247132
  },
  {
    "country": "Northern Ireland",
    "county": "Tyrone",
    "population": 177986
  }
]
    
  </script>
</pdq-json>`
    const codeStatements = `<pdq-search id="filtered-counties" sources='["counties"]' property-to-match="county"></pdq-search>
<pdq-table id="filtered-counties-tbl" source="filtered-counties"></pdq-table>
<pdq-perspective-viewer table="filtered-counties-tbl" height="200px"></pdq-perspective-viewer>
`
    const treeCode = `<pdq-transform id="taxonomy" sources='["counties"]'>
<script type="module" slot="transform">
  // build a taxonomy from the counties data
  // required shape is an array of objects with parentId, id, and title
  // since we don't have ids for country or county we just use the name for both
  // for large datasets use an int id for performance
  export async function transform(sources) {
    const [data] = sources
    const countries = [...new Set(data.map(i => i.country))].map(i => ({
      parentId: undefined,
      id: i,
      title: i
    }))
    
    const counties = data.map(i => ({
      parentId: i.country,
      id: i.county,
      title: i.county
    }))
    
    return [...countries, ...counties]
  }
</script>          
</pdq-transform>
      
<pdq-search id="filtered-counties2" sources='["counties"]' property-to-match="county"></pdq-search>
<pdq-table id="filtered-counties2-tbl" source="filtered-counties2"></pdq-table>
<div class="row">
  <pdq-filtered-tree id="country-county-tree" id-property="county" items-source="filtered-counties2" taxonomy-source="taxonomy" taxonomy-properties='["country", "county"]' class="w25"></pdq-filtered-tree>
  <pdq-perspective-viewer table="country-county-tree-tbl" height="500px" class="w75"></pdq-perspective-viewer>
</div>

<pdq-table id="country-county-tree-tbl" source="country-county-tree-items"></pdq-table>
<pdq-perspective-viewer table="country-county-tree-tbl" height="400px"></pdq-perspective-viewer>
`

    return html`
      <cds-tile>
        <h1>Search</h1>
        <p>The <cds-tag>pdq-search</cds-tag> control is an extension of the <cds-tag>pdq-transform</cds-tag> tag, 
          with a UI. It can be used with a full script in the transform slot for advanced use, but for most simple cases 
          its possible to just set the 
          <br><strong>id</strong> the output datasets name
          <br><strong>sources</strong> array of source datadsets, the first will be search by default
          <br><strong>property-to-match</strong> the property to search on
          <br> the default search is an unordered lowercase include search for every word in the search string
          
        </p>
        
        <h2>Example - Simple table</h2>  
        data (scrolled for bevity)...
        <pdq-code-html code="${data}" style="display:block; max-height: 100px; overflow-y: auto"></pdq-code-html>
        ${unsafeHTML(data)}
        code...
        <pdq-code-html code="${codeStatements}" style="display:block; max-height: 250px; overflow-y: auto"></pdq-code-html>
        ${unsafeHTML(codeStatements)}

        <br>
        <br>
        <br>
        <br>
        
        <h2>Example - Search with filtered tree</h2>
        <p>the <cds-tag>pdq-filtered-tree</cds-tag> works in a similar way, it is bound via these properties
          <br><strong>id</strong> the output datasets name prefix, outputs '{id}-tree-items' and '{id}-items' datasets
          <br><strong>items-source</strong> the tabular input dataset
          <br><strong>id-property (default id)</strong> the property to use as primary key for the items-source dataset
          <br><strong>taxonomy-properties</strong> properties from the items-source to use to match to the taxonomy dataset
          <br><strong>taxonomy-source</strong> the taxonomy dataset, array of objects with parentId, id, and title properties
          <br><strong>multiselect (default false)</strong> allow multiple selection on the tree
        </p>
        <pdq-code-html code="${treeCode}" style="display:block; max-height: 250px; overflow-y: auto"></pdq-code-html>
        ${unsafeHTML(treeCode)}
      </cds-tile>
    `;
  }
}